import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface ISkills {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  desktop_background_color?: string;
  mobile_background_color?: string;
  backvariant?: string;
  gradient_color_1?: string;
  gradient_color_2?: string;
  gradient_color_3?: string;
  gradient_color_4?: string;
  variant?: string;
  pre_title?: string;
  pre_title_color?: string;
  title?: string;
  title_color?: string;
  description?: string;
  description_color?: string;
  metadata?: any[];
  status?: boolean;
}

export async function createSkills(payload: Partial<ISkills>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.SKILLS.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateSkills(id: number, payload: Partial<ISkills>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.SKILLS.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
